import { useEffect } from 'react'
import { resolveRouteGroup, type RouteGroup } from './index'

// NOTE: ルートグループはアプリ起動時の pathname で一度だけ決まるため、別グループのパスへ
// クライアントサイド遷移すると、そのグループのルート定義を持たず未マッチになる。
// 実在するページの可能性があるので、リロードしてサーバーに処理を委ねる。
// 別グループへの遷移だったかを返すので、呼び出し側はリロード中の描画を抑止できる。
export const useOtherGroupReload = (loadedGroup: RouteGroup, enabled = true): boolean => {
  const isOtherGroup = enabled && resolveRouteGroup(window.location.pathname) !== loadedGroup

  useEffect(() => {
    if (isOtherGroup) window.location.reload()
  }, [isOtherGroup])

  return isOtherGroup
}
